import { NgModule } from "@angular/core";
import { RealPipeTransform } from "../pipes/real.pipe";

@NgModule({
    imports: [],
    declarations: [RealPipeTransform],
    exports: [RealPipeTransform]
})
export class PipesModule { }
